const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the content host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {Articles} Articles the resource defined to manage Articles
 * @argument {Videos} Videos the resource defined to manage Videos
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('contentHost', ['Application', 'Authorization', 'Analyze', 'Articles', 'Videos', 'Files', 'ImportedContent', 'Presentations', 'Assignments', 'Users', '$translate', function (Application, Authorization, Analyze, Articles, Videos, Files, ImportedContent, Presentations, Assignments, Users, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/content-host.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var params = Application.navigation.getRouteParameters();
      self.contentId = params.id;
      self.chartData = {};
      self.userNames = {};

      self.engage = Authorization.getAuthToken().company && Authorization.getAuthToken().company.engage;

      $translate(['manage.host.chart_lastWeek', 'manage.host.chart_lastMonth', 'manage.host.chart_allTime']).then(function(data){
        self.translations = data;
        self.initialize();
      });
      
      self.usertoken = Authorization.getAuthToken();
      self.isAdmin = function(){
        if (self.usertoken.user.role === 'admin') {
          return true;
        } else {
          return false;
        }
      };

      self.parseUrl = function () {
        var url = Application.navigation.getPath();
        if (/articles/g.test(url)) {
          return 'article';
        }
        if (/videos/g.test(url)) {
          return 'video';
        }
        if (/files/g.test(url)) {
          return 'file';
        }
        if (/imported-content/g.test(url)) {
          return 'imported_content';
        }
        if (/presentations/g.test(url)) {
          return 'presentation';
        }
        return null;
      };

      self.contentType = self.parseUrl();

      self.setTotals = function(data) {
        if (data.chart.items) {
          self.output.totals.views += data.chart.items.views.length;
          self.output.totals.comments += (data.chart.items.comments.length - data.chart.items.uncomments.length);
          self.output.totals.likes += (data.chart.items.likes.length - data.chart.items.unlikes.length);
          self.output.totals.shares += data.chart.items.shares.length;
        }
        if (data.chart.counts) {
          self.output.preChartTotals.views = data.chart.counts.views;
          self.output.preChartTotals.comments = data.chart.counts.comments - data.chart.counts.uncomments;
          self.output.preChartTotals.likes = data.chart.counts.likes - data.chart.counts.unlikes;
          self.output.preChartTotals.shares = data.chart.counts.shares;

          self.output.totals.views += self.output.preChartTotals.views;
          self.output.totals.comments += self.output.preChartTotals.comments;
          self.output.totals.likes += self.output.preChartTotals.likes;
          self.output.totals.shares += self.output.preChartTotals.shares;
        }
      };

      self.organizeData = function() {
        var iconDirectory = {
          'views': 'view',
          'likes': 'heart',
          'shares': 'share',
          'comments': 'comment'
        };
        self.chartData.xLabels = self.output.xLabels;
        self.chartData.initialActive = self.duration;
        self.chartData.periods = [
          {title: self.translations['manage.host.chart_lastWeek'], select: self.getChart.bind(self, 'week'), active: self.duration === 'week'},
          {title: self.translations['manage.host.chart_lastMonth'], select: self.getChart.bind(self, 'month'), active: self.duration === 'month'},
          {title: self.translations['manage.host.chart_allTime'], select: self.getChart.bind(self, 'all'), active: self.duration !== 'week' && self.duration !== 'month'},
        ];
        self.chartData.series = [];
        angular.forEach(['views', 'likes', 'shares', 'comments'], function(item) {
          self.chartData.series.push({
            title: item,
            data: self.output.dataSets[item],
            total: self.output.totals[item],
            iconClass: iconDirectory[item]
          });
        });
      };

      self.makeDataSets = function() {
        // TODO: use a sorting algo to find the position faster
        var findLocation = function(key) {
          key = parseInt(key);
          for (var i = 0; i < self.dataDates.fullList.length; i++) {
            if (key <= parseInt(self.dataDates.fullList[i])) {
              return self.dataDates[self.dataDates.fullList[i]].location;
            }
          }
          return null;
        };

        // set the place holders
        angular.forEach(self.output.xLabels, function(item, index) {
          self.output.dataSets.views[index] = 0;
          self.output.dataSets.likes[index] = 0;
          self.output.dataSets.shares[index] = 0;
          self.output.dataSets.comments[index] = 0;
        });

        // Add or subtract each item from correct indicie
        for (var item in self.originalData.chart.items) {
          var sign = item.slice(0, 2) === 'un' ? -1 : 1;
          choppedItem = item.slice(0, 2) === 'un' ? item.slice(2) : item;
          angular.forEach(self.originalData.chart.items[item], function(record) {
            if (!record.created_on) {
              console.log('record with no created_on date: ', record);
              return;
            }
            var key = moment(new Date(record.created_on)).format('YYYYMMDD');
            var location = self.dataDates[key] ? self.dataDates[key].location : null;
            if (!location && location !== 0) {
              location = findLocation(key);
              if (!location && location !== 0) {
                console.log('no place found for record: ', record)
                return
              }
            }
            self.output.dataSets[choppedItem][location] += sign;
          });
        }

        // set the running tally
        angular.forEach(['views', 'likes', 'shares', 'comments'], function(item, index) {
          var previous = self.output.preChartTotals[item];
          angular.forEach(self.output.dataSets[item], function(location, index) {
            self.output.dataSets[item][index] += previous;
            previous = self.output.dataSets[item][index];
          });
        });

        self.organizeData();
      };

      self.setDuration = function(data, duration) {
        var date = moment();
        self.dataDates = {fullList: []};
        switch (duration) {
          case 'month':
            var current = moment().subtract(1, 'month');
            self.output.xLabels = [];
            var attempt = 0;
            while (current <= date) {
              attempt++;
              self.output.xLabels.push(current.format('D MMM'));
              var key = current.format('YYYYMMDD');
              self.dataDates[key] = {date: new Date(current.valueOf()), location: self.dataDates.fullList.length};
              self.dataDates.fullList.push(key);
              current.add(1, 'days');
            }
            self.output.xLabels = self.output.xLabels.map(function(val, idx){ return (idx%2 == 0) ? '' : val });
            break;
          case 'all':
            // Find oldest
            // Make 12 occasions from current till then (including both)
            var oldest;
            for (var key in data.items) {
              if (data.items[key] && data.items[key].length) {
                if (!data.items[key][0].created_on) {
                  continue;
                }
                var item = moment(new Date(data.items[key][0].created_on));
                if (!oldest || item < oldest) {
                  oldest = item;
                }
              }
            }
            self.output.xLabels = [];
            if (!oldest) {
              break;
            }
            oldest = oldest.valueOf();
            var period = (date.valueOf() - oldest) / 11;
            for (var i = 0; i < 12; i++) {
              var itemPeriod = new Date(oldest + (i * period));
              var key = moment(new Date(itemPeriod)).format('YYYYMMDD');
              self.dataDates[key] = {date: new Date(itemPeriod), location: self.dataDates.fullList.length};
              self.dataDates.fullList.push(key);
              itemPeriod = moment(itemPeriod).format('D MMM');
              self.output.xLabels.push(itemPeriod);
            }
            break;
          default:
            var days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
            self.output.xLabels = [];
            var current = moment().subtract(6, 'days');
            var counter = 0;
            while (counter < 7) {
              var key = current.format('YYYYMMDD');
              self.dataDates[key] = {date: new Date(current.valueOf()), location: self.dataDates.fullList.length};
              self.dataDates.fullList.push(key);
              self.output.xLabels.push(days[current.day()]);
              current.add(1, 'days');
              counter++;
            }
            break;
        }
        self.makeDataSets();
      };
      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };
      self.getChart = function(duration) {
        if (!duration) {
          duration = 'month';
        }
        self.duration = duration;

        // reset outputs
        self.output = {
          xLabels: [],
          dataSets: {
            views: [],
            shares: [],
            likes: [],
            comments: []
          },
          totals: {
            views: 0,
            shares: 0,
            likes: 0,
            comments: 0
          },
          preChartTotals: {
            views: 0,
            shares: 0,
            likes: 0,
            comments: 0
          }
        };

        self.chartLoading = true;
        Analyze.reports({
          subresource: 'contenthost',
          content_id: self.contentId,
          duration: duration
        }).$promise.then(function(data) {
          self.originalData = data;
          if (!self.usersResolved) {
            if (data.recentViews.length) {
              self.viewTab = true;
            }
            self.modifications = data.modifications;
            if (self.modifications.length) {
              self.changeTab = true;
              self.resolveUsers();
            }
          }

          // set totals and duration specific data
          self.setTotals(data);
          self.setDuration(data.chart, duration);

          self.initLoading = false;
          self.chartLoading = false;
        });
      };

      self.getTitle = function() {
        switch (self.contentType) {
          case 'article':
            return Articles.get({subresource: self.contentId, fields: 'title,average_rating,rating_configuration'}).$promise
            break;
          case 'file':
            return Files.get({subresource: self.contentId, fields: 'title,average_rating,rating_configuration'}).$promise
            break;
          case 'video':
            return Videos.get({subresource: self.contentId, fields: 'title,average_rating,rating_configuration'}).$promise
            break;
          case 'imported_content':
            return ImportedContent.get({subresource: self.contentId, fields: 'title,average_rating,rating_configuration'}).$promise
            break;
          case 'presentation':
            return Presentations.get({subresource: self.contentId, fields: 'title,average_rating,rating_configuration'}).$promise
          default:
            break;
        }
      };

      self.slimDate = function(date) {
        return moment(new Date(date)).format('D-MMM-YYYY h:mm a');
      };

      self.resolveUsers = function() {
        if (self.usersResolved) {
          return;
        }
        self.usersResolved = true;
        var length = 0;
        var users = null;
        angular.forEach(self.modifications, function(mod) {
          var user = mod.user;
          if (!self.userNames[user]) {
            length++;
            if (!users) {
              users = '' + user;
              return;
            }
            users += ',' + user;
          }
        });
        return Users.find({
          fields: '_id,first_name,last_name,full_name,email,image,linked_departments,linked_locations',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name',
          _id: '$in,' + length + ',' + users
        }).$promise.then(function(users) {
          angular.forEach(users, function(user) {
            self.userNames[user._id] = user;
          });
        });
      };

      self.showAssignments = function() {
        var assignmentFilter = {
          page: 1,
          per_page: 1
        };
        var singleType = self.contentType === 'article' ? 'article' : 'media';
        assignmentFilter['$or'] = '4,' + assignmentFilter[singleType] + ',' + self.contentId + ',assigned_content.content_id,' + self.contentId;

        Assignments.find(assignmentFilter).$promise.then(function(items) {
          if (items.length) {
            self.assignmentTab = true;
          }
        });
      };

      self.initialize = function () {
        if (!self.contentId || !self.contentType) {
          Application.navigation.goToHome();
          return;
        }

        self.initLoading = true;
        self.getChart();
        self.getTitle().then(function(item) {
          self.contentTitle = item.title;
          self.allowRating = item && item.rating_configuration && item.rating_configuration.allow_rating;
          if (item.average_rating) {
            var outOfFive = Math.round(item.average_rating * 5) / 100;
            if (outOfFive) {
              self.rating = outOfFive;
            }
          }
        });
        if (self.contentType === 'imported_content') {
           return;
        }
        self.showAssignments();
      };

      // Set initial tab based on availability
      var tabs = ['viewTab', 'assignemtTab', 'changeTab'];
      angular.forEach(tabs, function(tab) {
        $scope.$watch('host.' + tab, function(newVal, oldVal) {
          if (newVal) {
            if (self[tabs[0]]) {
              self.activeTab = 'views';
              return;
            }
            if (self[tabs[1]]) {
              self.activeTab = 'assignments';
              return;
            }
            if (self[tabs[2]]) {
              self.activeTab = 'changelog';
              return;
            }
          }
        });
      });
    }],
    controllerAs: 'host'
  };
}]);
